import { BrowsePrimitivesIndexPage } from "@-/dev.improve.haniverse.routes.nav.app.browse.tabs.primitives.index";

export default function BrowsePrimitivesIndexRoute() {
  return <BrowsePrimitivesIndexPage />;
}
